import moment from '@/moment-gp'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},

  schema: {
    create({ message }, data) {
      return {
        timestamp:    moment.currentTimeServer('REALTIMEDB'),
        message:      message,
        unread:       true,
      };
    },

    fields: {
      timestamp: { validate_bolt_type: 'ServerTimestamp' },
      message: { validate_bolt_type: 'String' },
      unread: { validate_bolt_type: 'Boolean' },
    }
  }
};
